const signalrMethods = {
  ticketNewMessage: 'ticket:new-message',
  balanceChange: 'balance:change',
  earlyPaymentChange: 'early_payment:change',
} as const;

export type SignalRMethod = keyof typeof signalrMethods;
export type SignalRMethodName = (typeof signalrMethods)[SignalRMethod];

export { signalrMethods as default, signalrMethods };
